import {
  Home, Link2, FilePlus2, ClipboardList, LayoutDashboard, LineChart, Target, Table2,
  Wallet, CreditCard, Briefcase, Dices, Award, FileText, History, KeyRound, Users,
  FolderInput, Settings, Compass
} from 'lucide-vue-next'

export const ICONES_MENU = {
  Home, Link2, FilePlus2, ClipboardList, LayoutDashboard, LineChart, Target, Table2,
  Wallet, CreditCard, Briefcase, Dices, Award, FileText, History, KeyRound, Users,
  FolderInput, Settings, Compass
}
